var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXing(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.702 5.345c-.19 0-.351.067-.432.198-.083.136-.07.31.018.487l2.14 3.714c.003.007.003.011 0 .018l-3.362 5.95c-.088.174-.083.35 0 .486.08.13.223.216.414.216h3.163c.473 0 .701-.32.863-.613l3.416-6.057L8.747 5.94c-.158-.281-.396-.595-.881-.595H4.702zM17.993 1c-.473 0-.677.299-.847.605l-7.04 12.52 4.495 8.27c.157.282.4.605.884.605h3.16c.19 0 .34-.072.42-.203.084-.135.082-.314-.007-.49l-4.46-8.173a.018.018 0 01-.003-.01c0-.004.001-.007.003-.01l7.005-12.422c.088-.175.09-.354.006-.49-.08-.13-.23-.202-.42-.202h-3.196z",
    fill: "#71889D"
  })));
}
export default SvgXing;